import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { HomepageResults } from 'src/common/types/api/v4/search/v1/homepage';

import BoatTypeCard from 'src/common/components/BoatTypeCard';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import Carousel from 'src/common/components/dockyard/Carousel';
import CarouselButtons from 'src/common/components/dockyard/CarouselButtons';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import styles from './HomepageCategories.module.scss';

type HomepageCategoriesProps = {
  listingTypes: HomepageResults['listing_types'];
  layoutBackgroundColor: 'midnight02' | 'ivory';
  isCompact?: boolean;
};

const HomepageCategories: FC<HomepageCategoriesProps> = ({
  listingTypes,
  layoutBackgroundColor = 'midnight02',
  isCompact,
}) => {
  const [t] = useTranslation('home-page');
  const { isMobileNativeWebView } = useMobileNativeWebView();

  return (
    <div className={getClassNames(styles, 'layout', classNames({ isCompact }))}>
      <PitchPageLayout backgroundColor={layoutBackgroundColor}>
        <div className={getClassNames(styles, 'root', classNames({ isCompact }))}>
          <CarouselProvider>
            <div className={styles.header}>
              <div className={styles.title}>
                <Typography type="h3" size="display-5">
                  {t('categories--title')}
                </Typography>
              </div>
              <div className={styles.desktopButtons}>
                <CarouselButtons
                  variant="primary-dark"
                  spacing="together"
                />
              </div>
            </div>
            <Carousel>
              {listingTypes?.map((listing) => (
                <BoatTypeCard
                  key={listing.slug}
                  urlSegment={listing.slug}
                />
              ))}
            </Carousel>
            {!isMobileNativeWebView && (
              <div className={styles.mobileButtons}>
                <CarouselButtons
                  variant="primary-dark"
                  spacing="together"
                />
              </div>
            )}
          </CarouselProvider>
        </div>
      </PitchPageLayout>
    </div>
  );
};

export default HomepageCategories;
